<template>
    <div class="box">
        <div class="tabbar" v-if="!isApp" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logo.png" alt="" />
        </div>
        <div class="top-box">
            <img class="banner" src="/subject/frendbonst/banner.png" @click="joinActivity" alt="" />
            <img class="banners" src="/subject/frendbonst/wap/banner.png" @click="joinActivity" alt="" />
        </div>

        <div class="content">
            <div class="part">
                <div class="part1">
                    <img src="/subject/frendbonst/cart.png" alt="">
                    <img src="/subject/frendbonst/rule.png" alt="" class="rule" @click="controlPop = true">
                    <img src="/subject/frendbonst/button.png" @click="joinActivity" class="requests" alt="">
                </div>
                <div class="wappart1">
                    <img src="/subject/frendbonst/wap/cart.png" alt="">
                    <img src="/subject/frendbonst/wap/rule.png" alt="" class="rule" @click="controlPop = true">
                    <img src="/subject/frendbonst/wap/button.png" alt="" @click="joinActivity" class="recommon">
                </div>
                <div class="part2 clearfix">

                    <img src="/subject/frendbonst/cart1.png" alt="">
                    <img class="boxpart" src="/subject/frendbonst/box.png" alt="">

                    <div class="part2-bottom">
                        <img @click="live800" src="/subject/frendbonst/request.png" alt="">
                        <img @click="joinActivity" src="/subject/frendbonst/button1.png" alt="">
                    </div>
                    <div class="inputcont">
                        <input type="text" v-model="inviteNum" @input="changeNum" @blur="changeNum" placeholder="">
                        <span class="packet">{{ packet }}</span>
                        <span class="total">{{ totalnum }}</span>
                    </div>

                </div>
                <div class="wappart2 clearfix">
                    <img src="/subject/frendbonst/wap/cart1.png" alt="">
                    <img class="boxs" src="/subject/frendbonst/wap/boxs.png" alt="">
                    <img src="/subject/frendbonst/wap/request.png" @click="live800" alt="" class="request">
                    <img src="/subject/frendbonst/wap/button1.png" alt="" @click="joinActivity" class="recommon">
                    <div class="inputcont">
                        <input type="text" v-model="inviteNum" @input="changeNum" @blur="changeNum" placeholder="">
                        <span class="packet">{{ packet }}</span>
                        <span class="total">{{ totalnum }}</span>
                    </div>
                </div>
                <div class="part4">

                    <div class="flex">
                        <p class="title">有效邀请<span>5</span>人，成为推广之星，获得额外<span>588人民币</span><br />再获得【美金返赠特权】</p>
                        <img class="icon" src="/subject/frendbonst/icon.png" alt="">
                    </div>
                    <div class="wapflex">
                        <p class="title">有效邀请<span>5</span>人，成为推广之星，获得额外<span>588人民币</span></p>
                        <p class="tit">再获得【美金返赠特权】</p>
                        <img class="icon" src="/subject/frendbonst/icon.png" alt="">

                    </div>
                    <div class="detailTable">
                        <el-table :data="tableData" stripe border style="width: 1130px;margin: 0 auto;"
                            :header-cell-style="{ textAlign: 'center', color: '#000', border: 'none' }"
                            :header-row-style="{ height: '60px', background: 'linear-gradient(to right, #ffe9bf, #ffd9a2)' }"
                            :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                            <el-table-column prop="date" label="层级" min-width="30%">
                            </el-table-column>
                            <el-table-column prop="name" label="要求" min-width="40%">
                            </el-table-column>
                            <el-table-column prop="address" label="月交易手数(总和)" min-width="40%">
                            </el-table-column>
                            <el-table-column prop="back" label="每手返赠" min-width="40%">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="waptable">
                        <table class="tables">
                            <tr>
                                <th>层级</th>
                                <th>要求</th>
                                <th>月交易手数(总和)</th>
                                <th>每手返赠</th>
                            </tr>
                            <tr>
                                <th>L1</th>
                                <th>推广有效好友5人及以上</th>
                                <th>5≤N≤50</th>
                                <th>5美金</th>
                            </tr>
                            <tr>
                                <th>L2</th>
                                <th>推广有效好友8人及以上</th>
                                <th>50&lt;N≤500</th>
                                <th>8美金</th>
                            </tr>
                            <tr>
                                <th>L3</th>
                                <th>推广有效好友12人及以上</th>
                                <th>500以上</th>
                                <th>10美金</th>
                            </tr>

                        </table>
                    </div>
                    <p class="wapcont">
                        升级为「推广之星」，由专属BD经理服务，享受更多红利权益保障，上不封顶!<br />
                        小贴士:有效邀请人，以账户完成首次入金为标准。所有返赠按月发放，可绑定钱包提领到账。
                    </p>
                    <img src="/subject/frendbonst/button1.png" class="button1" @click="joinActivity" alt="">
                </div>

                <div class="part3">
                    <img style="width: 100%;" src="/subject/frendbonst/cart2.png" alt="">
                    <div class="app-box">
                        <div class="codeBody">
                            <div>MT4账户专用版本</div>
                            <div class="codeBox">
                                <div class="codeItem">
                                    <Qrcode :link="iosMt4DownloadUrl" :size="100" :iconSize="30" />

                                </div>
                                <div class="codeItem">
                                    <Qrcode :link="androidMt4DownloadUrl" :size="100" />

                                </div>
                            </div>
                        </div>
                        <div class="codeBody">
                            <div>MT5账户专用版本</div>
                            <div class="codeBox">
                                <div class="codeItem">
                                    <Qrcode :link="iosMt5DownloadUrl" :size="100" />

                                </div>
                                <div class="codeItem">
                                    <Qrcode :link="androidDownloadUrl" :size="100" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wappart3 clearfix">
                    <img src="/subject/frendbonst/wap/cart2.png" alt="">
                    <div class="download">
                        <img src="/subject/frendbonst/wap/MT4.png" @click="downloadMt4" alt="">
                        <img src="/subject/frendbonst/wap/MT5.png" @click="downloadMt5" alt="">
                    </div>
                </div>
            </div>

        </div>
        <!-- 活动规则 -->
        <div class="popup" v-if="controlPop">
            <span @click="closePop" class="closer1">X</span>
            <ul class="popContent">
               
                <li class="top-tit">
                    真金酬知己 荐面三重礼
                </li>
                <li class="top-cont">
                    邀好友赚赏金，成星级合伙人，月月收美金！
                </li>


                <li>
                    <span>人民币礼金三重奏 美元分红引爆推荐热潮</span><br />
                    <span> 活动时间：长期有效
                        </span>
                    <span>参与条件：本平台真实入金激活用户</span>
                    <span>第一重：即刻见面礼</span><br />

                    条件：好友通过您的专属链接注册并激活<br />
                    奖励：立即获得 88元 现金红包<br />
                    小贴士：无需等待，激活即得<br />


                </li>
                <li>
                    <span>第二重：成长鼓励礼</span><br />

                    条件：您的好友在有效期内完成1手有效交易<br />
                    奖励：获得 188元 现金红包<br />
                    小贴士：快来助力好友迈出交易1小步<br />


                </li>
                <li>
                    <span>
                        第三重：战队建设礼
                    </span><br />
                    条件：成功推荐有效邀请人3人，以及成功推荐有效邀请人5人<br />
                    奖励：有效邀请3人并完成对应交易要求，可获得288元现金红包<br />
                    有效邀请5人并完成对应交易要求，可获得588元现金红包 + 晋升【推广之星】<br />
                    小贴士：从个人推广到团队建设的华丽蜕变<br />
                    推荐越多，赚得越多！5人一组，组组皆明星。<br />
                    

                </li>
                <li>

                    <table>
                        <tr>
                            <th>奖励类型</th>
                            <th>条件</th>
                            <th>邀请人获得(RMB)</th>
                            <th>邀请人提取要求</th>


                        </tr>
                        <tr>
                            <th>好友注册奖励</th>

                            <th>好友通过专属链接注册并激活</th>
                            <th>88元</th>
                            <th>30天内可提取奖励</th>


                        </tr>
                        <tr>
                            <th>好友交易奖励</th>
                            <th>好友在有效期内完成1次有效交易</th>
                            <th>188元</th>

                            <th>30天内可提取奖励</th>



                        </tr>
                        <tr>
                            <th>黄金推手奖</th>
                            <th>需要3个有效邀请人，在有效期内完成首入并完成3手</th>
                            <th>288元</th>

                            <th>30天内可提取奖励</th>


                        </tr>
                        <tr>
                            <th>钻石伯乐奖</th>
                            <th>需要5个有效邀请人，在有效期内完成首入并完成5手</th>
                            <th>588元</th>

                            <th>30天内可提取奖励</th>


                        </tr>
                        <tr>
                            <th>5人组队福利汇总</th>
                            <th>(88+188)*5+288+588</th>
                            <th>2256元</th>

                            <th></th>


                        </tr>

                    </table>
                </li>
                <li>
                    <span>推广之星 专属红利返赠</span>

                </li>

                <li>

                    <table>
                        <tr>
                            <th>层级</th>
                            <th>要求</th>
                            <th>月交易手数(总和)</th>
                            <th>每手返赠</th>
                        </tr>
                        <tr>
                            <th>L1</th>
                            <th>推广有效好友5人及以上</th>
                            <th>5≤N≤50</th>
                            <th>5美金</th>
                        </tr>
                        <tr>
                            <th>L2</th>
                            <th>推广有效好友8人及以上</th>
                            <th>50&lt;N≤500</th>
                            <th>8美金</th>
                        </tr>
                        <tr>
                            <th>L3</th>
                            <th>推广有效好友12人及以上</th>
                            <th>500以上</th>
                            <th>10美金</th>
                        </tr>


                    </table>
                    升级为「红狮推广伙伴」，专属BD经理服务，享受更多红利权益保障<br />
                    <span>

                        小贴士：所有返赠按月发放，可绑定钱包提领到账。等级动态更新，次月重新评估。
                    </span>
                </li>

                <li>
                    <span>推荐方式</span>
                    <br /> ① 推荐人可复制分享链接或保存邀请海报，通过微信、QQ、邮箱等方式发送给好友，好友在专属推荐链接内开立真实账户即可完成推荐（如果遇到开启异常，可以复制链接到浏览器打开）
                   <br /> ② 推荐人将邀请码发送给好友，好友开立真实账户后，在用户中心内绑定邀请码后即可完成推荐。
                    活动奖励：
                   <br /> 人民币现金奖励：前往平台APP——我的——我的钱包 或 钱包余额 查看
                   <br /> 若逾期未完成交易要求或逾期未提现，视为自动放弃奖励权益，奖励将被回收 。
                   <br /> 美金返赠奖励：美金返赠周期是被推荐人注册后的90天内关系有效。每月 1 - 7 日，平台对上月所有分享奖励达标情况集中审核（含好友身份有效性、交易真实性等
                    ），审核通过后，奖励正式发放至对应交易账户，到账后可自由选择提现或继续用于交易操作 。

                    

                </li>
                <li>
                    <span>注意事项</span><br />
                   1. 参加原邀请好友活动的客户按照原活动规则执行，如有疑问请咨询客服；<br />
                    2. 参与活动的双方，需接受平台审核，如有异常套利恶意滥用平台政策者，双方都将取消奖励和参与资格；同一真实交易账户不可被多次邀请，每位被推荐人仅和1位推荐人绑定关系；<br />
                    3. 新户首入低于50美金无法参加本活动；交易手数的计算：本活动全品种手数可参与计算，开仓一手再平仓一手，如此来回为一手；<br />
                    4. 我平台保留随时修订、暂停、终止本活动及相关规则条款之权利及解释权。<br />
                    5.若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。<br />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>



import Qrcode from "@/component/QrCode/index.vue";
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { postLogin } from '@/apis/user';
import { encryptCBC } from "@/utils/IMEI";
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { Loading } from 'element-ui';
import { appLy, sendTicket, usercenter } from '@/apis/active'
import { getActicityParam } from '@/apis/transfer'
import { data } from "jquery";



export default {
    components: {

        Qrcode,
    },
    mixins: [userSign],

    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            timer: null,
            actives: 0,
            isApp: false,
            isLogin: false,
            isPC: true,
            isNumber: false,//是否账号密码登录
            loginStatus: false,//未登录
            inviteNum: '',//邀请好友数量
            packet: '',//获得红包
            totalnum: '',//总金额
            queryData: {},
            tableData: [
                {
                    date: 'L1',
                    name: '推广有效好友5人及以上',
                    address: '5≤N≤50',
                    back: '5美金'
                },
                {
                    date: 'L2',
                    name: '推广有效好友8人及以上',
                    address: '50<N≤500',
                    back: '8美金'
                },
                {
                    date: 'L3',
                    name: '推广有效好友12人及以上',
                    address: '500以上',
                    back: '10美金'
                },
                

            ],
            controlPop: false

        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };




    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                this.$emit("controlShow", false);

            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);

        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            this.queryData = queryData

            if (from === 'app_pm') {
                this.isApp = true;
                this.isPC = false
            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            // 用户中心首冲进入
            if (this.$route.query.type) {
                localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=') ? str.split("a=")[1] : '');
            }

            console.log('token', token)
            if (token) {
                const str = this.$route.query.isApp
                this.isLogin = true
                //h5携带参数截取


                localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=') ? str.split("a=")[1] : '');
                this.userKey = localStorage.getItem('token');
                this.loginStatus = false

            } else {
                this.isLogin = false
                this.loginStatus = true


            }
        }

        else {
            if (localStorage.getItem('token')) {

                this.userKey = localStorage.getItem('token');
                this.loginStatus = false


            } else {
                this.loginStatus = true

            }
        }

    },
    methods: {

        ...mapActions('common', {
            getTradeWapLink: 'getTradeWapLink',
        }),
        // 去登录
        async toLogin() {
            // 在安卓app
            if (window.android) {
                window.android.gotoLogin();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoLogin()
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
        },

        // 参加活动
        joinActivity() {
            // 未登录跳转用户中心登录
            if (!localStorage.getItem('token')) {
                if (this.isApp) {
                    this.toLogin()
                } else {
                    window.location.href =
                        window.location.origin + "/uc/login?";
                    //  "http://test.www.rlcvipltd.com/uc/login?";
                }


            } else {
                if (this.isApp) {
                    let fromUrl = this.queryData.fromUrl ? this.queryData.fromUrl : ''

                    window.open('https://testwww.rlc525.com/#/subject/frendfunction?a=' + this.queryData.a + '&phone=' + this.queryData.phone + '&accessKey=' + this.queryData.accessKey + '&from=' + this.queryData.from + '&fromUrl=' + fromUrl + '&formUrlType=' + this.queryData.formUrlType)


                } else {

                    // window.open(window.location.origin + "http://test.www.rlcvipltd.com/uc/specialEvent/inviteReward");
                    window.open(window.location.origin + "/uc/specialEvent/inviteReward");

                }


            }
        },

        // 计算时间差值
        constdiffInDays(date1, date2) {
            const data2 = new Date().getTime()

            const data1 = new Date(date1 + 8 * 3600000).getTime();
            console.log(this.getDateChange(data1), this.getDateChange(data2))
            let data = (data2 - data1)
            return Math.floor(data / (24 * 3600 * 1000))

        },
        // 时间戳转时间
        getDateChange(date) {
            var t = new Date(date).toLocaleString();
            return t;
        },
        // 发放包赔劵
        getTicket(id) {
            sendTicket({ activityid: id }).then(res => {
                console.log(res)
            })
        },
        selectlogin(type) {
            this.actives = type
            this.isNumber = false
            this.form.phone = ''
            this.form.code = ''

        },

        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },

        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度

            let scrollY = window.scrollY; //获取滚动后的高
            if (this.scroll > 90 && !this.isApp) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }


        },


        // ----------------------------登录注册
        selectAccount() {
            this.isNumber = true
        },
        selectAccount1() {
            this.isNumber = false
        },


        goback() {
            window.location.href = window.location.origin;

        },
        // mt4下载
        downloadMt4() {
            const userAgent = navigator.userAgent;
            console.log(userAgent);
            let deviceType = '';
            if (/android/i.test(userAgent)) {
                // 判断为安卓设备
                deviceType = 'Android';
                window.open(this.androidMt4DownloadUrl)
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                // 判断为苹果iOS设备，同时排除Windows Phone等可能包含'iPad'、'iPhone'、'iPod'字样的设备
                deviceType = 'iOS';
                window.open(this.iosMt4DownloadUrl);
            }
        },
        // mt5下载
        downloadMt5() {

            const userAgent = navigator.userAgent;
            console.log(userAgent);
            let deviceType = '';
            if (/android/i.test(userAgent)) {
                // 判断为安卓设备
                deviceType = 'Android';
                window.open(this.androidDownloadUrl)
            } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                // 判断为苹果iOS设备，同时排除Windows Phone等可能包含'iPad'、'iPhone'、'iPod'字样的设备
                deviceType = 'iOS';
                window.open(this.iosMt5DownloadUrl);
            }
        },

        // 输入框
        changeNum(e) {


            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
                console.log(this.inviteNum)

            }, 600)
            this.getTotal()

        },
        getTotal() {
            if(this.inviteNum != '' && this.inviteNum <= 3){
                this.packet = this.inviteNum * 2
                this.totalnum = this.inviteNum * (88+188)
            }
            else if (this.inviteNum != '' && this.inviteNum>3&& this.inviteNum <= 5) {
                this.packet = this.inviteNum * 2
                this.totalnum = this.inviteNum *(88+188)+288
                
            }
            else if (this.inviteNum > 5) {
                this.packet = 2 * this.inviteNum + Math.floor(this.inviteNum / 5)
                this.totalnum = this.inviteNum * (88 + 188) + 288+588
            }
            else {
                this.packet = ''
                this.totalnum = ''
            }
        },
        closePop() {
            this.controlPop = false
        },

    },

    computed: {
        ...mapState("common", {
            live800UrlUc: 'live800UrlUc',
            androidMt4DownloadUrl: "androidMt4DownloadUrl",
            androidDownloadUrl: "androidDownloadUrl",
            iosMt4DownloadUrl: "iosMt4DownloadUrl",
            iosMt5DownloadUrl: "iosMt5DownloadUrl",
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;


    .tabbar {
        width: 100%;
        background-color: #ffffff;

        img {
            margin: 20px 50px;
            width: 130px;
        }
    }

    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
        height: 600px;
        // padding-top: 75px;
        cursor: pointer;
    }

    .banners {
        display: none;
        cursor: pointer;
    }

    .btncount {
        position: absolute;
        top: 63%;
        left: 28%;
        width: 25%;
        height: 100px;
        z-index: 20;
        // background: red;
    }

    .count {
        position: absolute;
        top: 62%;
        left: 28%;
    }






    .top-box {
        position: relative;
        width: 100%;
    }

    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background: url(/subject/frendbonst/bg.png) no-repeat;
        background-size: 100% 100%;

        .parent-container {
            display: flex;
            justify-content: center;
            align-items: center;

            .dujia {
                margin-top: 130px;
            }
        }

        .part {
            // max-width: 1400px;
            width: 73%;
            margin: 0 auto;
            padding: 0% 13% 10%;


            .part1 {
                box-sizing: border-box;
                max-width: 1204px;
                margin: 0 auto;
                display: block;

                img {
                    width: 100%;
                }

                position: relative;

                .rule {
                    position: absolute;
                    top: 20%;
                    left: 2%;
                    width: 200px;
                    height: auto;
                    cursor: pointer;
                }

                .requests {
                    position: absolute;
                    right: 8%;
                    bottom: 22%;
                    width: 177px;
                    height: auto;
                }

            }

            .wappart1 {
                display: none;
            }

            .part2 {

                max-width: 1204px;
                margin: 0 auto;
                margin-top: 60px;

                box-sizing: border-box;
                position: relative;

                img {
                    width: 100%;
                }
                .boxpart{
                    width: 45.8%;
                    position: absolute;
                    top: 15%;
                    left: 3.7%;
                }
                .part2-bottom {
                    position: absolute;
                    width: 80%;
                    left: 10%;
                    bottom: 10%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    img {
                        width: 40%;
                        height: auto;
                        cursor: pointer;
                    }
                }

                .inputcont {

                    font-weight: 600;
                    // text-align: center;
                    font-size: 30px;

                    input {
                        background: #c5e2ff;
                        width: 44px;
                        height: 40px;
                        text-align: center;
                        line-height: 40px;
                        border: none;
                        position: absolute;
                        top: 32%;
                        right: 24.5%;
                    }

                    .packet {
                        position: absolute;
                        top: 47%;
                        right: 25%;
                    }

                    .total {
                        position: absolute;
                        top: 61%;
                        right: 22.5%;
                    }
                }



            }

            .wappart2 {
                display: none;
            }

            .wappart3 {
                display: none;
            }

            .part3 {
                box-sizing: border-box;
                max-width: 1204px;
                margin: 0 auto;
                display: block;
                margin-top: 60px;
                position: relative;

                .app-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: 10%;
                    left: 8%;
                }

                .codeBody {
                    >div:first-child {
                        font-weight: 700;
                        margin-bottom: 20px;
                        font-size: 20px;
                        text-align: center;
                        color: #fff;
                    }

                    .codeBox {
                        display: flex;
                        justify-content: center;
                        margin-bottom: 15px;
                        margin-right: 30px;

                        .codeItem {
                            &:first-child {
                                margin-right: 15px;
                            }

                            .canvasCode {
                                border-radius: 6px;
                            }

                            div {
                                line-height: 32px;
                                // line-height: 48px;
                                // background: #e4760b;
                                background: linear-gradient(150deg, #ff2c41 0%, #ff1232 100%),
                                    #ff3333;
                                color: #fff;
                                border-radius: 4px;
                                margin-top: 6px;
                                // font-size: 20px;
                                font-size: 14px;
                            }
                        }
                    }
                }
            }

            .part4 {
                box-sizing: border-box;
                max-width: 1204px;
                height: auto;
                margin: 0 auto;
                display: block;
                margin-top: 60px;
                position: relative;
                color: #fff;
                background: url(/subject/frendbonst/bg4.png) no-repeat;
                background-size: 100% 100%;
                padding: 78px 90px;
                font-size: 28px;

                .title {
                    font-size: 30px;
                    font-weight: 600;
                    margin-bottom: 20px;

                }

                .flex {
                    display: flex;
                    align-items: end;
                    margin-top: 30px;
                }

                .wapflex {
                    display: none;
                }

                .icon {
                    // width: 172px;
                    height: 172px;
                }

                p {
                    span {
                        color: #fff70c;
                    }
                }

                .detailTable {
                    width: 100%;
                    box-sizing: border-box;
                    background: url(/subject/frendbonst/bg5.png) no-repeat;
                    background-size: 100% 100% !important;
                    padding: 20px;
                    margin-bottom: 20px;

                    /deep/ .el-table__row {
                        height: 60px;
                    }

                    /deep/ .el-table__row--striped {
                        height: 60px;
                    }

                    /deep/ .el-table__row td {

                        color: #222 !important;

                        font-size: 18px !important;
                    }



                    /deep/ .el-table .cell {
                        white-space: pre-line;
                        font-size: 18px;
                    }

                    /deep/ .el-table {
                        background: url(/subject/frendbonst/bg5.png) no-repeat !important;
                        background-size: 100% 100% !important;
                        .el-table__header-wrapper,
                            .el-table__body-wrapper {
                                background-color: transparent;
                            }
                        
                            .el-table__row {
                                background-color: transparent;
                            }
                        
                            .el-table__cell {
                                background-color: rgba(255, 255, 255, 0.8); // 可选：添加半透明背景提高文字可读性
                            }
                    }

                }

                .waptable {
                    display: none;
                }
                

                .button1 {
                    width: 30%;
                    height: auto;
                    margin: 0 auto;
                    margin-top: 20px;
                    margin-left: 35%;
                }
            }
        }
    }







    /deep/ .el-dialog__header {
        display: none !important;
    }

    /deep/ .el-dialog__body {


        border: none !important;
        background: none !important;
    }

        .popup {
            overflow-x: hidden;
            width: 1100px;
            height: 900px;
            border-radius: 20px;
            background: #fdf5e6;
            position: fixed;
            top: 57%;
            left: 50%;
            transform: translate(-50%; -50%);
            box-sizing: border-box;
            padding: 10px;
            box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
            overflow-y: scroll;
            padding-bottom: 40px;
            z-index: 99999999999999;
    
            .closer1 {
                float: right;
                cursor: pointer;
                margin-top: 8px;
                margin-right: 10px;
            }
    
            .popContent {
                box-sizing: border-box;
                padding: 40px 50px 20px;
    
                .top-tit {
                    font-weight: 600;
                    color: #000;
                    font-size: 30px;
                    margin-bottom: 30px;
                }
    
                li {
                    font-size: 18px;
                    color: #a86e4f;
                    line-height: 36px;
    
                    span {
                        font-weight: 600;
                        color: #e34a3f;
                    }
    
                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }
    
                    table {
                        border: 1px solid #e34a3f;
                        border-radius: 15px;
                        width: 100%;
    
                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 50px;
                                border-bottom: 1px solid #d2a765;
                                border-right: 1px solid #d2a765;
                                padding: 5px;
                            }
    
                            th:last-child {
                                border-right: 1px solid transparent;
                            }
                        }
    
                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }

}


//--------------------------110----------------------
@media screen and (min-width: 1745px) and (max-width: 1897px) {
    .box {
        .popup {
                height: 800px;
            }
    }
}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1745px) {
    .box {}
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {



        .content .part .part1 .img-box1 div img {
            width: 238px;
            height: auto;
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        width: 100%;

        .btncount {
            position: absolute;
            top: 30%;
            left: 20%;
            width: 70%;
            height: 60px;
            z-index: 20;

        }

        .count {
            position: absolute;
            top: 30%;
            left: 20%;
        }



        .navBarFixed {
            position: fixed;
            top: 0;
            z-index: 999;
        }

        .banner {
            width: 100%;

            display: none;
            // padding-top: 75px;
        }

        .banners {
            display: block;
            width: 100%;
        }

        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/frendbonst/wap/bg.png) no-repeat;
            background-size: 100% 100%;

            .parent-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .dujia {
                    margin-top: 130px;
                }
            }

            .part {
                // max-width: 1400px;
                width: 100%;
                margin: 0 auto;
                padding: 4% 0% 10%;

                .part1 {
                    display: none;
                }

                .wappart1 {
                    display: block;
                    box-sizing: border-box;
                    margin: 0 auto;
                    width: 100%;
                    padding: 0 0.5rem;
                    position: relative;

                    img {
                        width: 100%;
                    }

                    .rule {
                        position: absolute;
                        top: 8%;
                        left: 32%;
                        width: 34%;
                    }

                    .recommon {
                        position: absolute;
                        bottom: 10%;
                        right: 10%;
                        width: 50%;
                    }
                }

                .part2 {
                    display: none;
                }

                .wappart2 {
                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 0 0.5rem;
                    position: relative;

                    img {
                        width: 100%;
                    }
                    .boxs{
                        position: absolute;
                        top: 9.8%;
                        left: 10.7%;
                        width: 80%;
                       
                    }
                    .request {
                        position: absolute;
                        top: 40%;
                        left: 24%;
                        width: 50%;
                    }

                    .recommon {
                        position: absolute;
                        bottom: 7%;
                        left: 24%;
                        width: 50%;
                    }

                    .inputcont {

                        font-weight: 600;
                        // text-align: center;
                        font-size: 16px;
                        background: #ff1232;

                        input {
                            background: #c5e2ff;
                            width: 22px;
                            height: 20px;
                            text-align: center;
                            line-height: 40px;
                            border: none;
                            position: absolute;
                            top: 59.5%;
                            right: 46.5%;
                        }

                        .packet {
                            position: absolute;
                            top: 68.5%;
                            right: 48%;
                        }

                        .total {
                            position: absolute;
                            top: 77%;
                            right: 42.5%;
                        }
                    }

                }

                .part3 {
                    display: none;
                }

                .wappart3 {
                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 0 0.5rem;
                    position: relative;

                    img {
                        width: 100%;
                    }

                    .download {
                        position: absolute;
                        bottom: 7%;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        img:nth-child(1) {
                            margin-bottom: 20px;
                        }

                        img {
                            width: 60%;
                        }
                    }
                }

                .part4 {
                    display: block;
                    margin: 0 auto;
                    margin-top: 60px;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 30px 2rem;
                    position: relative;
                    color: #fff;
                    background: url(/subject/frendbonst/wap/bg3.png) no-repeat;
                    background-size: 100% 100%;

                    font-size: 14px;

                    .title {
                        font-size: 1.1rem;
                        font-weight: 600;
                        margin-bottom: 0px;
                        // margin-left: 10px;

                    }

                    .tit {
                        font-size: 1.1rem;
                        font-weight: 600;
                        margin: 20px 0;
                    }

                    .flex {
                        display: none;
                    }

                    .wapflex {
                        display: block;
                   
                        margin-left: 1rem;
                        position: relative;
                        margin-top: 14%;
                    }

                    .icon {
                        // width: 172px;
                        height: 86px;
                        position: absolute;
                        bottom: -30px;
                        right: -4%;
                    }

                    p {
                        span {
                            color: #fff70c;
                        }
                    }

                    .detailTable {
                        display: none;

                    }

                    .waptable {
                        display: block;
                        color: #000;
                        position: absolute;
                        top: 35%;
                        left: 1rem;
                        width: 100%;

                        .tables {
                            background: url(/subject/frendbonst/wap/bg4.png) no-repeat;
                            background-size: 100% 100%;
                            font-size: 12px;
                            padding: 0.5rem;
                            width: 92%;

                            th {
                                height: 30px;
                            }
                        }
                    }

                    .button1 {
                        width: 50%;
                        height: auto;
                        margin: 20px 0 20px 25%;
                    }
                                        .wapcont {
                                            margin-top: 14rem;
                                        }
                }

            }
        }

        .popup{
            width: 95%;
                height: 480px;
                box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
                background-color: #fdf5e6;
                border-radius: 15px;
                overflow-y: scroll;
                z-index: 99999999;
            
                .closer1 {
                    width: 16px;
                    height: 30px;
                    height: auto;
                    position: absolute;
                    top: 5px;
                    right: 5px;
                    font-size: 20px;
                }
            
                .popContent {
                    box-sizing: border-box;
                    padding: 10px;
                    overflow: hidden;
            
                    .top-tit {
                        font-size: 16px;
                        margin-top: 20px;
            
                    }
            
                    li {
                        font-size: 14px;
                        color: #a86e4f;
                        line-height: 24px;
            
                        span {
                            font-weight: 600;
                            color: #e34a3f;
                        }
            
                        img {
                            width: 100%;
                            height: auto;
                            margin: 20px 0;
                        }
            
                        table {
                            width: 100%;
                            border: 1px solid #e34a3f;
                            border-radius: 10px;
            
                            tr {
                                th {
                                    text-align: center;
                                    font-weight: 500;
                                    line-height: 24px;
                                    border-bottom: 1px solid #d2a765;
                                    border-right: 1px solid #d2a765;
                                    padding: 5px;
                                }
            
                                th:last-child {
                                    border-right: 1px solid transparent;
                                }
                            }
            
                            tr:nth-child(1) {
                                th {
                                    font-weight: 600;
                                }
                            }
                        }
                    }
                }
        }
        /deep/ .el-dialog__header {
            display: none !important;
        }

        /deep/ .el-dialog__body {
            background: none !important;

            border: none !important;
            padding: 0 !important;
        }


    }

}
</style>
